export default {
    BOOK_CALL: 'https://calendly.com/coverflowteam/intro',
};
